import { render, staticRenderFns } from "./c_home_group.vue?vue&type=template&id=e31ea218&scoped=true"
import script from "./c_home_group.vue?vue&type=script&lang=js"
export * from "./c_home_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31ea218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e31ea218')) {
      api.createRecord('e31ea218', component.options)
    } else {
      api.reload('e31ea218', component.options)
    }
    module.hot.accept("./c_home_group.vue?vue&type=template&id=e31ea218&scoped=true", function () {
      api.rerender('e31ea218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_group.vue"
export default component.exports